/* This is generated code, don't alter */
var IfcPileTypeEnum;
(function (IfcPileTypeEnum) {
    IfcPileTypeEnum[IfcPileTypeEnum["BORED"] = 0] = "BORED";
    IfcPileTypeEnum[IfcPileTypeEnum["DRIVEN"] = 1] = "DRIVEN";
    IfcPileTypeEnum[IfcPileTypeEnum["JETGROUTING"] = 2] = "JETGROUTING";
    IfcPileTypeEnum[IfcPileTypeEnum["COHESION"] = 3] = "COHESION";
    IfcPileTypeEnum[IfcPileTypeEnum["FRICTION"] = 4] = "FRICTION";
    IfcPileTypeEnum[IfcPileTypeEnum["SUPPORT"] = 5] = "SUPPORT";
    IfcPileTypeEnum[IfcPileTypeEnum["USERDEFINED"] = 6] = "USERDEFINED";
    IfcPileTypeEnum[IfcPileTypeEnum["NOTDEFINED"] = 7] = "NOTDEFINED";
})(IfcPileTypeEnum || (IfcPileTypeEnum = {}));
const IfcPileTypeEnumCount = 8;
export { IfcPileTypeEnum, IfcPileTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcPileTypeEnum = new Int32Array([1, 0, 9]);
let prefixSumAddressIfcPileTypeEnum = new Uint32Array([0, 9, 19, 31, 38, 48, 56, 69, 82]);
let slotMapIfcPileTypeEnum = new Int32Array([5, 4, 7, 0, 3, 1, 6, 2]);
let encodedDataIfcPileTypeEnum = (new TextEncoder()).encode(".SUPPORT..FRICTION..NOTDEFINED..BORED..COHESION..DRIVEN..USERDEFINED..JETGROUTING.");
let IfcPileTypeEnumSearch = new MinimalPerfectHash(gMapIfcPileTypeEnum, prefixSumAddressIfcPileTypeEnum, slotMapIfcPileTypeEnum, encodedDataIfcPileTypeEnum);
export { IfcPileTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcPileTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcPileTypeEnumSearch, input, cursor, endCursor);
}
